import { useEffect, useState } from 'react';
function checkIsIos() {
  var userAgent = window.navigator.userAgent;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}
function useIsIOS() {
  var _useState = useState(__IS_CSR__ && checkIsIos()),
    isIOS = _useState[0],
    setIsIOS = _useState[1];
  useEffect(function () {
    setIsIOS(checkIsIos());
  }, []);
  return isIOS;
}
export default useIsIOS;